import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SignIn from '../SignIn';
import CampaignMagicLink from '../CampaignMagicLink';
import Profile from '../Profile';
import Root from '../Root';
import PaymentMethods from '../PaymentMethods';
import { Context } from '../../Context';
import { Mixpanel } from '../../Config/mixpanel';

export const PrivateRoute = ({ "component": Component, ...rest }) => (
	<Route {...rest} render={(props) => (
		<Context.Consumer>
			{(value) => {
				if (value.state && value.state.user && value.state.user.status === 'created' && props.location.pathname !== '/profile' && props.location.pathname !== '/payment-methods') {
					Mixpanel.alias(value.state.user._id);
					Mixpanel.identify(value.state.user._id, { '$distinct_id': value.state.user._id });
					Mixpanel.track('Registered', { userId: value.state.user._id });

					return (<Redirect to="/profile" />);
				}

				if (value.state && value.state.user && value.state.user.status !== 'created' && props.location.pathname === '/profile') {
					return (<Redirect to="/" />);
				}

				return (localStorage.getItem('token') ? <Component {...props} /> : <Redirect to="/auth/signin" />);
			}}
		</Context.Consumer>
	)} />
);

const Router = () => (
	<div className='wrapper'>
		<Switch>
			<Route exact path="/auth/signin" component={SignIn} />
			<Route exact path="/ac/:magicLink" component={CampaignMagicLink} />

			<PrivateRoute exact path='/profile' component={Profile} />
			<PrivateRoute exact path='/payment-methods' component={PaymentMethods} />

			<PrivateRoute exact path='/account' component={Root} />
			<PrivateRoute exact path='/account/payment-methods' component={Root} />
			<PrivateRoute exact path='/campaigns/:campaignId' component={Root} />
			<PrivateRoute exact path='/campaigns/' component={Root} />
			<PrivateRoute path='/' component={Root} />
			<Route component={() => (<div>404 Page not Found</div>)} />
		</Switch>
	</div>
);

export default Router;
